<template>
    <el-dialog :visible="visible" width="60%" @close="handleClose" :close-on-click-modal="false" class="dialog"
               :title="title" top="6vh">
        <div class="page">
            <div class="main">
                <div class="ask_body" >
                    <div v-for="(ask,indexs) in data" :key="indexs">
                        <div class="but">
                            <h4>{{indexs+1}}、{{ask.questionTitle}} ({{ask.titleType==1?'单选':'多选'}})
                                <el-popover
                                        placement="top-start"
                                        title=""
                                        width="300"
                                        trigger="hover"
                                        :content="ask.titleExplain">
                                    <el-button slot="reference"> <i class="el-icon-warning-outline"></i></el-button>
                                </el-popover>
                            </h4>
                        </div>
                        <el-row style="margin-left: 10px">
                            <el-checkbox-group v-model="ask.answerOptions" v-if="ask.titleType=='2'" ref="checkboxGroup">
                                <el-row>
                                    <el-col :span="6" style="margin: 5px 0"
                                            v-for="(item,index) in ask.answerOption" :key="index">
                                        <el-checkbox :label="item.AnswerOption" border disabled>{{item.AnswerTxt}}
                                        </el-checkbox>
                                    </el-col>
                                </el-row>
                                <el-row class="check_list" v-if="!ask.answerOption.length">
                                    <div :class="ask.answerOption==''?'you':'wu'">无</div>
                                </el-row>
                            </el-checkbox-group>
                            <el-radio-group v-model="ask.answerOptions" v-if="ask.titleType=='1'">
                                <el-radio :label="item.AnswerTxt" ref="radios" disabled border
                                          v-for="(item,index) in ask.answerOption" :key="index">{{item.AnswerTxt}}
                                </el-radio>
                            </el-radio-group>
                        </el-row>

                    </div>
                </div>
            </div>
            <div style="text-align: right;padding: 10px">
                <el-button type="primary" @click="handleClose">确 定</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            visible: {
                default: false
            },
            data: {
                default: []
            },
            title: {
                default: "问卷"
            },
        },
        data() {
            return {
                wenhao: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAAGwkGG9AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAATKADAAQAAAABAAAATAAAAAA1ceXaAAATP0lEQVR4AdVcDXQdxXWe2fdkyX/YxICxT6E2KZDaJ0BBP5Qau7JkbEs6tKFJOEkIIWnTQJo2hJOT1G1DEvJDQ3to80OAQxto7JaTE1IwkSyDJKs2xEGyHCDENClp7ODE/CU2xrbQz9udfnf23X2zs7Pv7ZOeHLrnvDcz9965c+fOnZk7P7tCWM/jj/94fm//0PsscCnZ3Tekevr23FmCCEEwM50EGNgYcXff8NcZxwgOCd7TN/RrQTIxkRmahBT3jo0dvcokoDghuta1SBteMR1xjyLFLJB5O+feNrDnRo7r0CYmIBF19w/fQvGYHFQ7KO5NhKCnrJzg8pGQzPFvF9vTNzwGOX8ekdoEEQIREG6NNRkTc0jEOm4CmEMCZgOQLjBxFNpEEaIY6e7f86c2LCYjISMmFMETU65JEENEuUAhpbyjs71ZKzZGRLnp6d6593fFROHZMOX+dzVb3iTlErvWXEKFOAty0hftVmdgSVylcQHMxKYh3fT0DwcE9zQRqmQTEZwYnXlqbhbhinjfZg6dqXqRW6jhZJU2AUthhkRTjo5wXkdb09fMTK44EUopxlzSm/RhNQGhrmAi7LhSosGGcTosTN4RtVjYp9TZlUpnBhSOjIzUvXjEnxANs9/UdfkFRyJmTKT7n1BXUpoUu25d41HGUaj7ggr+RcOKTBifYMYIDrt3DF8lA3G+yKm+ztaWEYa7Qieznv6hSegoZtBmZmTa3Lmu5VoTRvEYs22Dey8NCoXvEyJNd6jmOUIF/1uOJhxLYQK9/cNNRFjpQQv+jFrRSUeIR55+eq4TmQLEmP2EyVBXkwDoFrsxlPyBmW9b3/A/BEJ9PIJ54u+62lq+EKURCZlJ9M3mnLdv375ZhLQZ9fcPLSJGKORG0h+eF0UgPm8yonioW6WN39t/6Pg4ukpi8B1T4ldEjEK+XAyXUNg9MFySlADFZ3v/3st18+fr5DkM5NBuzcHBJxeeKEwI7+xTv8o0ZlhQhV1avPVrmg+aCDuObjMHjI4QvOPcc8dtPGq2lWBRR7cJzDT63wlY5HFbWoNGuxiaWe+OofUGIhbtHhh6BwG62lucPgnh0FvWSiFfgM7kqO8r8hZivYGI6IEpfBuBE6cJin/Lls5d5sE+yhoq2ZFpmCYDim/fNaJbeeXKlRORztIySOHdZDMw04Vx/xAa4G4Tpi0Zs0xvDFghUVbqEDmcaHoXTxejhGK5umidnZ3rmv/QZkRzJPsRtqkkmFFmc8yymVHaZsI0TmaMdIU0MBx44fi3YFt/7MInYXI056lrNra1PJjEpUMyCYYp9WUl1OkmGxpoMMreVlcn77K7Nql0++DwFYEvPgOaS818FJee/EBnW/O9NtxMpwpG3nUQBP/ExK5xmHFZw97+vRf4qvA004OnwmgZdRuGU5gQzJzriKDujIZ56y+88ATFa/lQV4NmNxBPCDgJAfXcwWXEBMP64xUMTKcRMidl88b25j1MWC4sug/XYVR7M1rxoCfF5o725n8vl4dx8GvQdVUolOG3RIKhO9LklKMMaT2FmVGIGn8XNe4yYa44bPG2zvaWT7pwDIPZfAVm85c6Lb03d7U3/UwLBn/nQe5lWYSCZn8Eza4kRih4Bwpu40I45HFHp2VubVd74yDjXCEquhMVXU04kkEbHgsFi/uiK1MCVhSK4C6hbHpPqeU2zE7DxtYwDM3bL8k+hK++Q8As2uLMaeHgoMqfKAxPMp6GFQhfx+lyYXf/0FNCiQuJJk8+L8aaaT9oBg/N4UMo5uWjoqnuMBOZIaabZzBehoKRIw6fTDchmKPnyqrl3Pbcc/UQKlrXTFXzMKlow8QzVwfb+od3mzXIHP/5qx+FfR6jH3WGzPkShGqOBkn56XDUzck/IQBUdamedBMZygPQhbYi83z6KU/eUZ7ajYXGA8Z0tTffogXrWtv8nxg3NmsEVi/bd/xAtzMTVgp9P/hxRFPsSFE6Q4TGUDIjImUz0AnO2zMw/H4VqG8U0/tBdA7jZiKkpQqvMIg/C0XxmGAEoIfUyjUAwRAWkwkPIaSc2r8tEMp4D8r4D5ObUzAmgIATEDAagzzP+yq2Kv6K8dWE5IXDeaaVj572KK9LIOZZVjAm6n7sh6eKsTEs6sKVH8OjUIqnwegAijoGmqUwF2i42MMiojCCXns3BtzrLXAimUmwRC4AaDVZUP6nIUBiniR6WjkJT9697Mw5t9JaxcWjHGzKgjHTnsGhRs8XKwMhl2JwPhZIdWjhrFP6Vq16C7Q39adqwXoHht7mB3JLWlPZoqDpHlq2ZN7V1Wots2DY+/gmBuD32gVnTdNkruryF2Af9L+z5KkomDW2RTyR8QkvJz6zobX5UXt+fWTn8FmTk+p60HwC819sIoftvYJ14RkRo5RIWcF4j5Dzguk4pvkV5GEyLEsIPjgbUTeYtF4+//sdrZc8YcLMeKpg5iBLGfK5uos2rL04WuGYTLLGwfN7GBcvY3qMix/DuPjPnDZDp2Axt1iImk5NtEHoKxU5bWnCJQQzR3vYzna4vBvNmtQiTpuOky+PHWdermYN3Z4iBWxhK09BkHhoJoSiomidSutVFoz3bDlNYaSxcNp5/XCIlBPYoao3CdPiNCGPC3kz8I341Qkl99bNzn3uilUXH0rLw3CzWe3eWhKsb9hHz9EahKY8ewhgZhxCszmsB7HNnTxCIhoatzramuvBJ3IAOa8ZxjrErPwKHue0IKHXWtyahQeRQShaeETOnVkQx2n8Ag0qW/6BEqJ9aTlZ+CFTa8GkCqKtgCxuDQbdo8wAmhmbm2+uIyePftLz3s04CiHcA2baHZf6NJkqw/vfWjBMNfpoFO28053RgioRGS5cmNmtrTLa++5sa7rfE160846m1usJi0MsCXv+MANo743iHrkvDJwlvD/ieFrYu2NPRwmXYj/LFn6uRJMtRjZJlNCa3hD0Qp8qzGyfILlYYvPjLQwHs70cN8O6A0cXm+kscbTabSYdJli3o2cSmXE03e1I0y/1mRDBSAkpR0vx9BjtTE5OqL8hCrpSoG1Mk8M9Ts+WHYOdoC3mtmg+J5qz5Da3S1+deG1d5JJgQDuQhUE5GuzV/heMfQ3TYNj5yoa1zfs4nTX0lFwaCRYuJLJmTdJhj+0hUyjPk3+OAfaeJGVlCPjMNwRTSytncVNsHxi5uBD4UY/OidzlG9saH3dTV4Z6Qh2KbCxcclXO5KLwg2AHw2ESPRvXVS8UtBRNj0FO7MM+LpZZ+nGvA7nAciGMfQHj5+SbMx5McI4wpHMBhtAOFOxM3MWAKYfFLSj4KsfMWaAafnRYYdJLmpvoSFUDpfdn8Of/1SQ4WfGS1yxH6VDQM9d7Uqgp9SIs7b5PjLGH+uJUKmLuydG5E/EIvQvcsKEEGSAfQVI6y4MB9RpMJ+FukBKLMZZlOngweUulnuU0H4ZpweATfYQRxR0ZTlYM4VHqk5QSYXiyUkqXj9H5EjqP9pbRLTczdTRcYELms1XyTG9kgkphuPwqeRk4qqlq8WIeepmXOqKxgwQoGaAQDVKc1t7e8utKgk0Hj/Jo4byceNhHhZHGdAE4ZNIh/mgLkm7ecLrWITzbXvDUQkGs5+3zy5hgdO0HNqN7BQlC14FoFVRzoXA5BR1tA/Gl9QWGh9+2y4gJRkh9nCdl5IGS5qqxObsAM029HmvXcfTiFobTiozjZhizMROBw4j3YId4iwHz8/W5szasbixOYQYmQzR29Ad6aCpxeGqySRWMiOKL4DAbqV4J+cEsM0Rf38gCeLNbMRxEPlqRy8NovsgbCWHx/7KCMSl8rbsgzYc4HQ/lKGTFdpLEylvNRzMt4xO0OB2lMKw0NJxGtpzExSGZBOMs6Elfg538BaezhijksJJeUzX7alUJxoLouxcvjm4SgfoQmmkJw+OhHMjL3Gc3tF/yWByeLTUlwbKxTlJRhQ6+MNZSEH4rmns1Cl+RXrFkfoKQ/whzeRaRXXmRGzxrScOQ6Yi4c9UOOmMKI08GXtRN8FjehQpGE0rtRE9yQmUOYxi6H4PG7dWYc5JTOqRmCqMRT46/fiuG9g9i0HCO5WXEGBVSPQdhyGXAeQqdSNGj5uOPBqBF2A48F+k5Gpz5TwYYyO5R9bM3ZRmgsrCdlsKKR3L3oSJXliuMpgrgH0PLf7NeyQey7NyU48c4mlbGpXo7LPlawC6niZhx7lA+jNH9uukor0IB7mJpcocG7oWAab6aj737r3t18tapTvjukitDab0STKpN2CqjjcCcKwc5DxgqrrNPlF20NqwqhWExdAsK+pTNhNIkBH6f2Li28ctFi3KRnVQYWVzvjpGPBoH6EnrBLGfhcDtxk+JmJ84BzKQwLGXfDY1scZk8GAzVS1yHmuEli0P2qkD6iESJHvSMyG9mBrqBlbomi8WVVVhxjHoKrXM2M+cQhWxfvNC7srGxMbqLxbg3ckhLvpdeDR5G4+tVUFxW+TzGuIvKjXGpCks7akYB+7EIbnqjW1RcEclU8ZYMnQQtt7H2otvEOxWWtuZIO4Q1GVYT7+kbeasQ/iZ0k3cin3OAtvj5cFy/g9/fd6xretLCTSlJS2Xz/jEzoS0c10WahMKw/tkMc402B4oM/JzMX7yx/ZLosI4ZVxvSWcfR11/7bnKFWS0nPdFswR7TtdOdZIoXrH8ACWKNBuUkXiaKKcy1WERrjufqveW1cA8wy96MWfazaaqBMFh0igG8IHFQCOwRC3EuVtd0+xdOa+rj1+W9i9a3Nv0olSIDgtwRfzzYj4bUO4ecBY0RvcRIsEhh5uVcg5j2Jn6nFsuMbX17Ph+I4G+Ztxl6Mve2jvbGh0yYHccwcR68hGfc7oEcnZs/fVFr6/IxO1816eJy7qe2N5DzxFWx/WB99OyX9mK5kOJGDu1ATuvp739mcZqycjmvs5KyqHCMJ/8Dy6NbE45HzRnzX77agagKRIZBdbYz0U00rSMg9JrvAG2JWOs0mN4TYFCTc5EJNbbeFoLStPOwcW3TNhfOBetc1/gM5HrNhUNFrY18F1VlGNWZ6h6nVHP2v3DirwkWLpKxfxQnAAK31GzYVNML55757fzceYvs34LZp5xfDc+egaHrMaOe4syTy33PCZ8C0FV3rIavJ1aSbmGqgohupoT85Whne9O86c4+U5DVmYXGFPiF38Ie2jtcBJDzPux2v9+FmwpMl9e/53ii1+VFk0dXVm2mtLf7RlDW7t0HZ+MUpwezN95idSsL5yO31FJZpAuqO+nA1gvpKk/3e6FJC0cb4b+5hxR1ZPRQz+ETh1pTpcA7EfT6QSp+2gh9GBDjQrrKQ5vHYIIxBBRIG3e/kQdn1V+AovSFHlsATBInvJx8ZzUThc0jezqpA9JVnm6O20ygvmU27GSk4djeB8f2fa6yQl+o+UEXbiZgLh2Qrjy6Zp8oEG900Z3tBHwGAb19I6vSlIU1bAc7jjMoQsRa1734VlsERIR05YXvJMgBE0FxuuBuw2Yy7Qv/91L4/xTrRTopP2mPu+5ygHQFH43fQCnsMiXCar0wS+VOq9X+u8n7jRzXx8/S/xWG9bwpp778hntmGkiHmuGVvdLL55RhQgYPI9MaM+NMxjH5eI8MPvnWgpo8z5PeodyiWU/NxJvV5epAdbaVBeN5aGN7eClPWxgx0KfGh47TIal1hijvNG8Wlytsqjj6dgZ2QZ+Ews6zeWBmmsSmS3NnazN2fmf2oQ+FKRHEhiIo6PCypfOW8GFxuDSCHASg83zqinGx1A10ZSMOq23qpSPBp1zKolIAr8Mrzv9W2xKT3KiOCWVBF6QTVhblihRGCb1axytV8HUDSvNDr7bD26b3cyKLZFwtQinzm7UlpTDDmwD3pqCmDaY6Ud2ojnFmMtCvl1kvWjkVoE+xx8Z+gs200y0mEzkpVmX9QEI8b+UUPrJzGRYdH4ZQK0D9SzRcd0db4z1QZqwBK3PKRhG+MCMehx3HjuDgIL+iGhrOdx2GOBXGxdGrSGCWONVGpqH8GQ1tJ3tAZrmmG9I7WYWXxwYwXieO3NBIZS9jlVUYCUbfBFG+v0uPJZakaPnt+dPr3/7/RXFaUa+MP4C6bLCqEh5E53Kry72jSHkqKowZp52uFPH78S2Tq2eqq7IMUw2L76rRe0PLXTyqOQ3LrDAuiBSHFrqdBkuGmSGsbrcncjfU4oTJ5FttnE6CAuHfCTkvc+WFnPSNjJvCm80uCjfMWWk3aRwafr7HR6slT8WZkk6cME58A/b+jzQDM3wmQn2zXuHTb0J8wD75iZcnn/fyuasrdb14nlJqygorscC7KfjYBL5L96XkrGpShXHt5ykxAvvcgR2IXdiuefaK1U2/oBZPUpcgZNGP7trzW4GvVvgBbi/ic2sYUBptr7yUoxSjWQ8O1Cft29oliuyxmijMLI6+8CknCptQmXdlqYyZt1bxYqPcr2blb+XXV2vGu1aM0vjQkmv/Sye64Aa+F0ZyBbpwlbcI0zgzXF+XfhQfkNm8fPHcbtMrZ4pahjW3sGqF01cHJo+eD2WenQtwP1x689H99I4vuukxvDp8zPcQSvX8groFP5nuJzKqlc+m/z8FHFqKnT0G6QAAAABJRU5ErkJggg=='
            }
        },
        methods: {
            handleClose() {
                this.$emit('close')
            },
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .el-dialog__body {
        padding: 10px;
    }
    .page {
        background: #fff;
        /*min-height: 100vh;*/

        .main {
            margin: 0 20px ;
            height: 600px;
            overflow: scroll;
        }
        .but ::v-deep .el-button {
            border: 1px solid #ffffff;
        }
        ::v-deep .el-checkbox.is-bordered.is-checked {
            border-color: #409EFF !important;
        }
        ::v-deep .el-radio.is-bordered.is-checked {
            border-color: #409EFF !important;
        }
        ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #409EFF !important;
        }
        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #409EFF  !important;
            border-color: #409EFF  !important;
        }
        ::v-deep .el-radio__input.is-checked .el-radio__inner, .el-radio__input.is-indeterminate .el-radio__inner {
            background-color: #409EFF  !important;
            border-color: #409EFF  !important;
        }
        ::v-deep .el-radio__input.is-checked+.el-radio__label {
            color: #409EFF  !important;
        }
        .top {
            padding: 0 10px;
            height: 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .left span {
            display: block;
            width: 70px;
            height: 30px;
            line-height: 30px;
            color: #000;
            border-radius: 30px;
            text-align: center;
            font-size: 12px;
            padding-left: 10px;
            background: rgba(7, 7, 7, .1) no-repeat left 8px top 7px url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAKKADAAQAAAABAAAAKAAAAAB65masAAAEb0lEQVRYCb2Z72tbVRjHz3OSuHa2nbbYJneVNm2lShWWRhhVUEF9416UTgXfFPTlcO6FG6IiDgb6QopvrAriKxFRHGud/gFTh+Bsk4FWLbamMndvslHIbNrNNTnH77nzhtM0Te69uc2F5J77nOfHJ+c859cNMZ/X3UPJweKmGBfEksSkATeGZCzGJCMiZuLZRNEkyVKRCJ+9tDS/7CcUeTHqGXyom4rXjzImJwBzvxdbBFoA8Mxeftt0JvNjzq2tK8CRkcfaVtfzx6VkJ+C4za3zanoIuM6IT3Xd3jG1sHCuUE1Hl9UFjPWNHhYkPkDX9eiGjZaRBleQDC9mM+nTtXzxnSqllBTtP3BSMHE6aDgVE73RLYX8MtqXOKVi7cRRtaJ3bKy1aN74RDL5zE6GQcoxqs7wLj5pzs9vVPrd1oLq1zQTTgEh5uHSaunTai25DTAWT55sVsttaS3JJqL9o6e2yPAQ0gWxgcTTyIv3Iava9bpuvTIx2sBA+AV6sXq6Wv0j7Z3Gb4W8teDIyi2ophIRIByj0CEMhDknkOu7lNPDww+3O/plwNX1f04EMVrR9Jjn2FPZlblzThAvd+ThXfkbG684NjZgPH6wR0px3BH6vd+Co0PZlfS3fn0oO/h5ue++pJ0aNuCGuHkU8gBWiMbhFCAG6d6b18VLqmwDYrGfUA9+r6BaTo+Ptd5m4r2Do0N4GNErvZR3A07FRy7ea8QfHObFohz3AqTrKjjihAHRWM7pPvWykGKcYxVM6kK3ZQfOyqS/c2vjXU8kOfLPy0Rqx2gOnApFMTVI1G7Y9dU8OHvHY3DM9q4BmwmnWgzxDI5vDGK3F3HkRMStdgB6EvHsA44rX5hAW0sl9vX+gcTjrgwaVELLmSoHLS9+mgmJ3ZDF1dHQC6DSbSKkyZGE3rdEzYIkOcfFnvCs1xZ09J2WNAYSTziyIO9hzmd5bvFCBse/n/06VpCixM4GDYkd+a9/L6eW/t/NsBm/gMpuNyAxgs8o3zYgC7NpzIdrSuD3ChiywMKt7ykWGzC7lL7Kid7xC+fYBQWJ6WUqt/zDlTKgKlAnfxffnuZEB0y/lyHjB57U5a7LxHKyo3vK0S8fO9csa3NfZ+wPrM3PoRILTEMXlkN6FoOvBV6iHjzJEIUms4vny4O2DKicrOWzix13RDeRoEEsZWGPcAwL/ZvWSuoj/QdtAVQVhWvZ79vujA2j+ICuuNtlvJ/5AjvzY5Vxbo3iCml7OPoCuuezCvGuPQLu8xa27/lqAWrmWk9/4lWcXt6CYdUfUs2hR5mE4zesvy6+vZPdti7WFdfz2fNtXUYKkI9C3qHXNV4mM8Rp0lq5+HEtX3VbJvdn6puI0XoPuvw1fK7VcuaqTvkg9nrEaBkyM+mz9WxqdnGlce/IWGep8O8RzHV4iS6TlfW1nrG2poizGb4n8uHl3y+s1tLV6zwB6ob7hw72lkqb40wKgJL6C8LAXw7qhEg4yppwjH2mNPHCPMV56Ctz+adLur3b8n/iS5gBbZhMpgAAAABJRU5ErkJggg==");
            background-size: 15px 15px;
        }

        .right {
            color: #999;
            font-size: 16px;
            margin-left: auto;

            b {
                color: #1989fa;
                font-size: 24px;
            }
        }

        .next {
            text-align: center;
            padding: 20px;
            display: flex;
            justify-content: center;
            align-items: center
        }

        .next span {
            height: 50px;
            width: 180px;
            text-align: center;
            border: 1px solid #171f30;
            display: inline-block;
            line-height: 50px;
            border-radius: 50px;
            font-size: 17px;
            color: #fff;
            background: #171f30;
        }

        .ask_tit {
            display: flex;
            justify-content: flex-start;
            align-items: center
        }

        .ask_tit strong {
            font-size: 19px;
            color: #333;
        }

        .ask_tit span {
            font-size: 16px;
            color: #666;
            font-weight: bold;
            margin: 0 5px;
        }

        .ask_tit img {
            width: 20px;
            height: 20px;
        }

        .all {
            padding: 20px;
        }

        .ask_body {
            /*padding-top: 15px;*/

        }

        .title {
            text-align: center;
            line-height: 30px;
            border-bottom: 1px #eee solid;
            padding-bottom: 10px;
        }

        .check_list {
            width: 120px;
            margin: 10px;
            height: 40px;
            border-radius: 50px;
            color: #333;
            font-size: 16px;
            text-align: center;
            background: #eee;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
        }

        .selected {
            color: #fff;
            display: block;
            width: calc(48vw - 20px);
            height: 50px;
            font-size: 18px;
            border-radius: 50px;
            background: #1989fa url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEXUlEQVR4Xu3aSasdVRTF8f8yDvwAOnDg2IHgyG+gJDYRFUMUI9EQiEoUNCiKKEogBAIhdqixV2wRERERERX7Bv0ADp04tu91yQ438oh18qrevnXvfe/tM3zUvu/wu2tXnTrnihopAaWqq5gCTIagAAswKZAsrwQWYFIgWV4JLMCkQLK8EliASYFkeSWwAJMCyfJKYAEmBZLllcACTAokyyuBBZgUSJZXApcA2t4g6e8hpgUI2N4EPAicBrwB7JD0XR/IdQ9oewvwAnDiErDDkq4twGUEbG8FnjsGL6q+knRWAR5HwPblwLPAho7L7pF0UwE2BGxvA55u4H0BnCPpxwLsELB9JfBUA+8zYJOkH/rgxTXr6iFiezvwJHBCB9AnwLl9k3e0ft0A2t4BPNbA+wg4fyjeukmg7Z3Ao42O+3CC91Pftl163ZpPoO1dwMMNvPeBCyT9vBK8NZ9A27EYjjeMrqC8B2yW9MtK8dY0oO3dwP0NvHeACyX9msFbs4C2bwDua+C8DVw0Dbw1CWj7RuBQA+8t4GJJv2WTtyaXMbb3AAcbOG8Cl0j6fVp4gxJo+xTgEeBs4Gtgt6R47VmIYfsW4EBjMrFFdem08YYCvghctmSC8eiPxecH8xa0fRuwvzGP14Etkv4YY56914G2vwVOPWYSgXiepFiMzmXYvh3Y1/jnrwFbx8IbmsC4AW/smGis4COJM0e0fSewt4H3anSMpD/H/GaHJPB0IN4ZT14ERNt3AXc3cF4BLpf015h4gxIYF9s+E4hFaAsx2jmQRx22I3WRvq7xMnDFLPAGA/ZEjC2hj8cStB33u7jvdY2XgG1DT9Yyc+3dwkv/SY8kjoJoO5608cTtGs8D22eJt6IEHp35MoixHR6IsUk5lWE71nix1usacbZx9azxUoA92nlqiLbj7SLeMrrGM5Nz3H+m8k0N/JAVtfCAdg7EOGP4dOC8/rvcdrzXxvtt14izjZ2S5oKXTuCAdl4Rou3YUYmdla7xOLBrnnhTA+zRznHKFYhx6rXssB2dEXt5safXNWJ7/hpJXvbDRr4g3cID2rkX4gQvdpFbP604DFy3CHhTTWDPdg7EjZI+7wrGBC/OL+Ico2sE7PWLgjcKYM92/h/iBC9aM07QusYDklr3w5Ebtf3xU23hAe38/SSJR/YTbcdBd5zZxtlt17hXUutJPDe80RLYs52PIAJfAk8AVzUkDklqrQHnijc6YI92DsTYBtvckDgo6ea5Kx1nAqO18IB2bk3vgKRbFxlvJgns2c7HOu2X1NpxWSjTmSRwIOI+SXcslNK8W3hAO++VFDvNq2bMNIFLkhjHA7Htfsbkb3HQvUfSQ6tGbjLRuQBOns4nxU9pgThvflfSN6sNb6YPkdWI02fOc0tgn8mthmsKMPktFWABJgWS5ZXAAkwKJMsrgQWYFEiWVwILMCmQLK8EFmBSIFleCSzApECyvBJYgEmBZHklsACTAsnySmAS8F+K9FNgVuM22QAAAABJRU5ErkJggg==') no-repeat right 10px center;
            background-size: 22px 22px;
        }

        .no_select {
            font-size: 18px;
            display: block;
            width: calc(48vw - 20px);
            height: 50px;
            font-size: 18px;
            border-radius: 50px;
        }

        .wu {
            font-size: 18px;
            display: block;
            width: calc(48vw - 20px);
            height: 50px;
            font-size: 18px;
            border-radius: 50px;
            line-height: 50px;
        }

        .you {
            color: #fff;
            display: block;
            width: 130px;
            height: 40px;
            /*font-size: 18px;*/
            border-radius: 10px;
            background: #1989fa url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEXUlEQVR4Xu3aSasdVRTF8f8yDvwAOnDg2IHgyG+gJDYRFUMUI9EQiEoUNCiKKEogBAIhdqixV2wRERERERX7Bv0ADp04tu91yQ438oh18qrevnXvfe/tM3zUvu/wu2tXnTrnihopAaWqq5gCTIagAAswKZAsrwQWYFIgWV4JLMCkQLK8EliASYFkeSWwAJMCyfJKYAEmBZLllcACTAokyyuBBZgUSJZXApcA2t4g6e8hpgUI2N4EPAicBrwB7JD0XR/IdQ9oewvwAnDiErDDkq4twGUEbG8FnjsGL6q+knRWAR5HwPblwLPAho7L7pF0UwE2BGxvA55u4H0BnCPpxwLsELB9JfBUA+8zYJOkH/rgxTXr6iFiezvwJHBCB9AnwLl9k3e0ft0A2t4BPNbA+wg4fyjeukmg7Z3Ao42O+3CC91Pftl163ZpPoO1dwMMNvPeBCyT9vBK8NZ9A27EYjjeMrqC8B2yW9MtK8dY0oO3dwP0NvHeACyX9msFbs4C2bwDua+C8DVw0Dbw1CWj7RuBQA+8t4GJJv2WTtyaXMbb3AAcbOG8Cl0j6fVp4gxJo+xTgEeBs4Gtgt6R47VmIYfsW4EBjMrFFdem08YYCvghctmSC8eiPxecH8xa0fRuwvzGP14Etkv4YY56914G2vwVOPWYSgXiepFiMzmXYvh3Y1/jnrwFbx8IbmsC4AW/smGis4COJM0e0fSewt4H3anSMpD/H/GaHJPB0IN4ZT14ERNt3AXc3cF4BLpf015h4gxIYF9s+E4hFaAsx2jmQRx22I3WRvq7xMnDFLPAGA/ZEjC2hj8cStB33u7jvdY2XgG1DT9Yyc+3dwkv/SY8kjoJoO5608cTtGs8D22eJt6IEHp35MoixHR6IsUk5lWE71nix1usacbZx9azxUoA92nlqiLbj7SLeMrrGM5Nz3H+m8k0N/JAVtfCAdg7EOGP4dOC8/rvcdrzXxvtt14izjZ2S5oKXTuCAdl4Rou3YUYmdla7xOLBrnnhTA+zRznHKFYhx6rXssB2dEXt5safXNWJ7/hpJXvbDRr4g3cID2rkX4gQvdpFbP604DFy3CHhTTWDPdg7EjZI+7wrGBC/OL+Ico2sE7PWLgjcKYM92/h/iBC9aM07QusYDklr3w5Ebtf3xU23hAe38/SSJR/YTbcdBd5zZxtlt17hXUutJPDe80RLYs52PIAJfAk8AVzUkDklqrQHnijc6YI92DsTYBtvckDgo6ea5Kx1nAqO18IB2bk3vgKRbFxlvJgns2c7HOu2X1NpxWSjTmSRwIOI+SXcslNK8W3hAO++VFDvNq2bMNIFLkhjHA7Htfsbkb3HQvUfSQ6tGbjLRuQBOns4nxU9pgThvflfSN6sNb6YPkdWI02fOc0tgn8mthmsKMPktFWABJgWS5ZXAAkwKJMsrgQWYFEiWVwILMCmQLK8EFmBSIFleCSzApECyvBJYgEmBZHklsACTAsnySmAS8F+K9FNgVuM22QAAAABJRU5ErkJggg==') no-repeat right 10px center;
            background-size: 22px 22px;
            line-height: 40px;
        }

        .tips {
            color: #f53625;
            font-size: 14px;
            padding: 10px 0
        }

        .check_list1 {
            width: 150px;
            margin: 8px 1vw;
            height: 40px;
            border-radius: 50px;
            color: #333;
            font-size: 16px;
            text-align: center;
            background: #eee;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
        }

        .selected1 {
            color: #fff;
            display: block;
            width: calc(100vw - 40px);
            height: 50px;
            font-size: 18px;
            border-radius: 50px;
            background: #1989fa url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEXUlEQVR4Xu3aSasdVRTF8f8yDvwAOnDg2IHgyG+gJDYRFUMUI9EQiEoUNCiKKEogBAIhdqixV2wRERERERX7Bv0ADp04tu91yQ438oh18qrevnXvfe/tM3zUvu/wu2tXnTrnihopAaWqq5gCTIagAAswKZAsrwQWYFIgWV4JLMCkQLK8EliASYFkeSWwAJMCyfJKYAEmBZLllcACTAokyyuBBZgUSJZXApcA2t4g6e8hpgUI2N4EPAicBrwB7JD0XR/IdQ9oewvwAnDiErDDkq4twGUEbG8FnjsGL6q+knRWAR5HwPblwLPAho7L7pF0UwE2BGxvA55u4H0BnCPpxwLsELB9JfBUA+8zYJOkH/rgxTXr6iFiezvwJHBCB9AnwLl9k3e0ft0A2t4BPNbA+wg4fyjeukmg7Z3Ao42O+3CC91Pftl163ZpPoO1dwMMNvPeBCyT9vBK8NZ9A27EYjjeMrqC8B2yW9MtK8dY0oO3dwP0NvHeACyX9msFbs4C2bwDua+C8DVw0Dbw1CWj7RuBQA+8t4GJJv2WTtyaXMbb3AAcbOG8Cl0j6fVp4gxJo+xTgEeBs4Gtgt6R47VmIYfsW4EBjMrFFdem08YYCvghctmSC8eiPxecH8xa0fRuwvzGP14Etkv4YY56914G2vwVOPWYSgXiepFiMzmXYvh3Y1/jnrwFbx8IbmsC4AW/smGis4COJM0e0fSewt4H3anSMpD/H/GaHJPB0IN4ZT14ERNt3AXc3cF4BLpf015h4gxIYF9s+E4hFaAsx2jmQRx22I3WRvq7xMnDFLPAGA/ZEjC2hj8cStB33u7jvdY2XgG1DT9Yyc+3dwkv/SY8kjoJoO5608cTtGs8D22eJt6IEHp35MoixHR6IsUk5lWE71nix1usacbZx9azxUoA92nlqiLbj7SLeMrrGM5Nz3H+m8k0N/JAVtfCAdg7EOGP4dOC8/rvcdrzXxvtt14izjZ2S5oKXTuCAdl4Rou3YUYmdla7xOLBrnnhTA+zRznHKFYhx6rXssB2dEXt5safXNWJ7/hpJXvbDRr4g3cID2rkX4gQvdpFbP604DFy3CHhTTWDPdg7EjZI+7wrGBC/OL+Ico2sE7PWLgjcKYM92/h/iBC9aM07QusYDklr3w5Ebtf3xU23hAe38/SSJR/YTbcdBd5zZxtlt17hXUutJPDe80RLYs52PIAJfAk8AVzUkDklqrQHnijc6YI92DsTYBtvckDgo6ea5Kx1nAqO18IB2bk3vgKRbFxlvJgns2c7HOu2X1NpxWSjTmSRwIOI+SXcslNK8W3hAO++VFDvNq2bMNIFLkhjHA7Htfsbkb3HQvUfSQ6tGbjLRuQBOns4nxU9pgThvflfSN6sNb6YPkdWI02fOc0tgn8mthmsKMPktFWABJgWS5ZXAAkwKJMsrgQWYFEiWVwILMCmQLK8EFmBSIFleCSzApECyvBJYgEmBZHklsACTAsnySmAS8F+K9FNgVuM22QAAAABJRU5ErkJggg==') no-repeat right 10px center;
            background-size: 22px 22px;
        }

        .no_select1 {
            font-size: 18px;
            display: block;
            width: calc(100vw - 40px);
            height: 50px;
            font-size: 18px;
            border-radius: 50px;
        }

        .content {
            line-height: 24px;
            padding: 10px 5px;
            color: #666;
            font-size: 14px;
        }

        .img img {
            width: 100%;
        }
        ::v-deep .el-checkbox__input.is-disabled+span.el-checkbox__label {
            color: black;
        }
        ::v-deep .el-radio__input.is-disabled+span.el-radio__label {
            color: black;
        }
    }

</style>
